// src/components/Benefits.jsx

import React from "react";
import FeatureCard from "./FeatureCard";
import "./Benefits.css";
import Icons from "../assets/icons";
import { Fade } from "react-awesome-reveal";

const benefitsData = [
  {
    iconName: Icons.EficienciaOperacional,
    title: "Operação 24x7 & Observabilidade",
    description:
      "Monitoramento contínuo, SLA definidos e resposta a incidentes. Estabilidade operacional e visibilidade ponta a ponta.",
  },
  {
    iconName: Icons["data-infrastructure-engineering"],
    title: "Administração de Banco de Dados",
    description:
      "Gestão proativa, patching e governança de mudanças. Ambientes padronizados, confiabilidade auditável e desempenho consistente.",
  },
  {
    iconName: Icons.Continuidade,
    title: "Alta Disponibilidade & Continuidade",
    description:
      "Arquiteturas HA/DR validadas e testes periódicos de failover/switchover. RTO/RPO assegurados e continuidade do negócio.",
  },
  {
    iconName: Icons.SegurancaInformacao,
    title: "Segurança de Dados",
    description:
      "Princípio do menor privilégio, segregação de funções e trilhas de auditoria. Conformidade com LGPD/HIPAA/GDPR e proteção de dados.",
  },
  {
    iconName: Icons.InovacaoTecnologica,
    title: "Inovação Tecnológica",
    description:
      "Desenvolvimento de produtos e modelos de IA focados em reduzir custos operacionais e acelerar resultados do negócio.",
  },
  {
    iconName: Icons.TomadaDecisaoInteligente,
    title: "Tomada de Decisão Inteligente",
    description:
      "Dados confiáveis e painéis executivos. Indicadores operacionais e estratégicos para decisões rápidas e mensuráveis.",
  },
];

const Benefits = () => {
  return (
    <section id="benefits" className="benefits-section">
      <div className="container">
        <div className="benefits-header">
          <h2>
            Resultados que <span className="highlight">Impulsionam</span>
          </h2>
          <p>
            Com nossas soluções, sua empresa ganha agilidade, segurança e
            inteligência para se destacar no mercado e alcançar um crescimento
            sustentável.
          </p>
        </div>
        <div className="benefits-grid">
          {benefitsData.map((benefit, index) => (
            <Fade
              key={benefit.title}
              direction="up"
              delay={index * 100}
              triggerOnce
            >
              <FeatureCard
                iconName={benefit.iconName}
                title={benefit.title}
                description={benefit.description}
              />
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
